<template>
  <div>
    <!-- 批量修改 -->
    <!-- 头部 -->

    <Head />
    <!--  -->
    <div class="informationMaintenanceDetail">
      <!-- 详情 -->
      <div class="detail">
        <div class="detail-body">
          <!-- 菜单  -->
          <div class="menu">
            <!-- 基础设置 -->
            <div class="item" v-for="(item, index) in menu" :key="index" :class="{ select: content == item.value }"
              @click="switchContent(item)">
              {{ item.name }}
            </div>
            <div class="btn">
              <!-- 已选中管理番号 -->
              <el-popover placement="top" width="200" trigger="hover">
                <p v-for="(item, index) in sys_code_set" :key="index">{{ index + 1 }}：{{ item }}</p>
                <el-button type="danger" slot="reference">{{ $t('message.selectedManagementNumbers') }}</el-button>
              </el-popover>
              <!-- 一键提交  -->
              <el-button type="primary" style="margin-left: 20px;" @click="oneClickSubmission">{{
                $t('message.oneClickSubmission') }}</el-button>
            </div>
          </div>
          <!-- 内容 -->
          <div class="content-item">
            <component :is="content" :detail="detail" :ref="content" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/header/detailHeader'
import basicSettings from './components/basicSettings'
import productLabelManagement from './components/productLabelManagement'
import optionSettings from './components/optionSettings'
import purchaseInformationMaintenance from './components/purchaseInformationMaintenance'
import productFileManagement from './components/productFileManagement'
import controlOverInvoices from './components/controlOverInvoices'
export default {
  components: {
    Head,
    basicSettings,
    optionSettings,
    productLabelManagement,
    purchaseInformationMaintenance,
    productFileManagement,
    controlOverInvoices
  },
  computed: {
    menu() {
      return [
        { name: this.$t('message.basicSettings'), value: 'basicSettings' },
        // 购买信息维护
        { name: this.$t('message.purchaseInformationMaintenance'), value: 'purchaseInformationMaintenance' },
        // 商品标签管理
        { name: this.$t('message.productLabelManagement'), value: 'productLabelManagement' },
        // option设置
        { name: this.$t('message.optionSettings'), value: 'optionSettings' },

        //  商品文件管理
        { name: this.$t('message.productFileManagement'), value: 'productFileManagement' },
        // 注意事项
        // { name: this.$t('message.mattersNeedingAttention'), value: ' mattersNeedingAttention ' },
        // 发票管理
        { name: this.$t('message.controlOverInvoices'), value: 'controlOverInvoices' },
      ]
    }
  },
  data() {
    return {
      sys_code_set: [],
      detail: {
        client_product_supply_type: []
      },
      content: 'basicSettings',
      a: {
        "id": 130,
        "sys_code": "",
        "user_id": 6034,
        "client_sku_code": "02",

        "option": null,

        "is_hide": 0,
        "edit_status": 2,
        "client_product_link": [
          {
            "id": 429,
            "sys_code": "6034__02",
            "sku_code": "743509065d3ff2ba94598aa85d568367",
            "pic": null,
            "client_product_image_real": [],
            "item_sku": {
              "id": 11831,
              "item_code": "p-ec2c1c272eb9f5d88b7e0ae97116968b",
              "sku_code": "743509065d3ff2ba94598aa85d568367",
              "sku_id": "",
              "detail": [
                {
                  "key": "カラー",
                  "value": "支架+包装+绒布袋"
                },
                {
                  "key": "サイズ",
                  "value": ""
                }
              ],
              "pic": "https://cbu01.alicdn.com/img/ibank/2020/001/543/18628345100_37064226.jpg",
              "is_on_sale": 1,
              "item": {
                "id": 4645,
                "item_code": "p-ec2c1c272eb9f5d88b7e0ae97116968b",
                "from_platform": "1688",
                "goods_id": "622342494171",
                "pic": "https://cbu01.alicdn.com/img/ibank/2020/001/543/18628345100_37064226.jpg",
                "price": "0.00",
                "goods_title": "",
                "goods_title_cn": "",
                "shop_id": "56ddee0e1862e600aedca3d9e116bb38",
                "shop_name": "麦迪隆科技",
                "is_on_sale": 1,
                "created_at": "2025-03-21 17:06:21"
              }
            },


          }
        ],
        "client_product_flag": [],
        "client_product_tag": [],
        "client_product_supply_type": [],
        "client_product_image_pack": [],
        "client_product_file_cate": [],
        "client_product_material": [],
        "client_product_clearance": null,
        "client_product_buy_channel": null,
        "rowNumber": 1
      }
    };
  },
  created() {
    if (this.$route.query.sys_code_set) {
      this.sys_code_set = this.$route.query.sys_code_set.split(',')
    }
    console.log(this.sys_code_set);

    this.detail = this.a
    // this.switchContent({ value: this.content })
    // this.productList()
  },
  methods: {
    // 无需维护列表
    productList() {
      let datas = {
        sys_code: this.$route.query.sys_code
      }
      this.$api.productManagementApi.productList(datas).then(res => {
        this.detail = res.data.data[0]
        this.switchContent({ value: this.content })
        console.log(this.detail);

      })
    },
    // 切换内容
    switchContent(item) {
      this.content = item.value
      this.$nextTick(() => {
        // this.$refs[this.content].setData(this.detail)
        this.$forceUpdate()
      })
    },
    //一键提交
    oneClickSubmission() {
      this.$refs[this.content].setData(this.sys_code_set)
    },
  }
}
</script>
<style lang='scss' scoped>
.informationMaintenanceDetail {
  min-width: 1910px;

  .breadcrumb {
    margin: 24px 30px;
    display: flex;
    height: 52px;
    background: #F8F8F8;
    border-radius: 8px;
    padding-left: 23px;

    .item {
      font-size: 14px;
      color: #666666;
      margin-right: 9px;
      line-height: 52px;
    }
  }

  .detail {
    margin: 24px 30px;

    background: #F8F8F8;
    border-radius: 6px;


  }

  .detail-body {
    margin-top: 24px;
    border: 1px solid #DFDFDF;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 24px;

    .menu {
      display: flex;
      border-bottom: 1px solid #DFDFDF;

      .item {
        margin-right: 36px;
        padding-bottom: 12px;
        border-bottom: 4px solid transparent;
        font-size: 18px;
        color: #333333;
        cursor: pointer;
      }

      .select {
        border-color: #B4272B;
        font-weight: bold;
        font-size: 18px;

      }

      .btn {
        .el-button {
          transform: translate(0, -10px);
        }
      }
    }

    .content-item {
      margin-top: 24px;
    }
  }
}
</style>